import React, { createContext, useEffect, useState } from 'react'
import Button1 from '../../../../components/form/Button1'
import { Modal3 } from '../../../../components/DIsplay/Modal/Modal3'
import CustomTable from '../../../../components/Table/CustomTable';
import Icon from '../../../../components/HOC/Icon';
import { enqueueSnackbar } from 'notistack';
import getIntraverseCommissions from '../../../../controllers/SplitCommission/getIntraverseCommissions';
import IntraverseCommissionForm from '../../../../components/Settings/IntraverseCommission/IntraverseCommissionForm';
import deleteIntraverseCommission from '../../../../controllers/SplitCommission/deleteIntraverseCommission';
import { Switch } from '@mui/material';
import activateIntraverseCommission from '../../../../controllers/SplitCommission/activateIntraverseCommission';
import deactivateIntraverseCommission from '../../../../controllers/SplitCommission/deactivateIntraverseCommission';
import useAccount from '../../../../hooks/useAccount';

export default function SplitCommission() {
    const [data,setData] = useState([]);
    const [loadings,setLoadings] = useState({load: false,delete: false})
    const [openTaxForm,setOpenTaxForm] = useState(false);
    const [openEdit,setOpenEdit] = useState(false);
    const [openDelete,setOpenDelete] = useState(false);

    const {checkPermission} = useAccount();
    
    useEffect(() => {
        load()
    },[])

    async function load() {
        setLoadings({...loadings,load: true})
        const res = await getIntraverseCommissions();
        setLoadings({...loadings,load: false})
        if(res?.return) {
            setData(res?.data?.data);
        }
    }

    const columns = [
        {field: 'name',headerName: 'Name',flex: 1},
        {field: 'commission',headerName: 'Amount',flex: 1},
        {field: 'method',headerName: 'Method',flex: 1},
        {field: 'status',headerName: 'Status',flex: 1},
        {field: 'action',headerName: '',flex: 1,
            renderCell: (params) => (
                <ActionCol params={params} />
            )
        },
    ]
    console.log(data)

    async function handleDelete() {
        setLoadings({...loadings,delete: true})
        const res = await deleteIntraverseCommission(openDelete);
        setLoadings({...loadings,delete: false})
        if(res?.return) {
            enqueueSnackbar(res.msg,{variant: 'success'})
            setOpenDelete(false);
            load();
        } else enqueueSnackbar(res.msg,{variant: 'error'})
    }
    async function handleChangeStatus(id,val) {
        setLoadings({...loadings,changeStatus: true})
        let res = {return: 0,msg: '0XICAD'};
        if(val)
          res = await activateIntraverseCommission(id);
        else
          res = await deactivateIntraverseCommission(id);
        setLoadings({...loadings,changeStatus: false})
        if(res?.return) {
            enqueueSnackbar(res.msg,{variant: 'success'})
            load();
        } else enqueueSnackbar(res.msg,{variant: 'error'})
    }

    const actions = {
        edit: (data) => {
            setOpenEdit(data);
        },
        remove: (id) => {
            setOpenDelete(id);
        },
        changeStatus: (val,params) => {
            handleChangeStatus(params?.row?._id,val);
        }
    }
    
    
  return (
    <div className='flex flex-col gap-4'>
      <div className='flex gap-4 items-center justify-between'>
        <h5>Intraverse Commission</h5>
        <div>
          {checkPermission(['create:intraverse-commission']) ? 
            <Button1 onClick={() => setOpenTaxForm(true)}>Add Commission</Button1>
          :null}
        </div>
      </div>

      <ActionContext.Provider value={actions}>
        <CustomTable loading={loadings?.load} rows={data} columns={columns} />
      </ActionContext.Provider>

      <Modal3 open={openDelete} setOpen={() => setOpenDelete(false)}
        title='Delete Commission'
      >
        <div className='card p-6 flex flex-col gap-4'>
            <div className='text-xl'>Are you sure you want to delete this commission?</div>
            <div className='flex gap-4 items-center'>
                <dib>
                    <Button1 variant='text'>Cancel</Button1>
                </dib>
                <Button1 loading={loadings?.delete} onClick={handleDelete} className='!bg-red-500 !text-white'>Delete</Button1>
            </div>
        </div>
      </Modal3>
      <Modal3 open={openEdit} setOpen={() => setOpenEdit(false)}
        title='Edit Commission'
      >
        <div className='flex flex-col gap-4'>
            <IntraverseCommissionForm data={openEdit} callback={load} close={() => setOpenEdit(false)} />
        </div>
      </Modal3>

      <Modal3 open={openTaxForm} setOpen={() => setOpenTaxForm(false)}
        title='Add Comission'
      >
        <div className='flex gap-3 flex-col'>
            <IntraverseCommissionForm callback={load} close={() => setOpenTaxForm(false)} />
        </div>
      </Modal3>
    </div>
  )
}


const ActionContext = createContext();


function ActionCol({ params }) {
  const {checkPermission} = useAccount();
  
  return (
    <ActionContext.Consumer>
      {(value) => {
        const {edit, remove, changeStatus} = value || {};
        return (
            <div className="flex gap-2 ">
              {checkPermission(['update:intraverse-commission']) ?
                <Switch
                  checked={params?.row?.status === "Active"}
                  onChange={(ev) => changeStatus(ev.target.checked, params)}
                />
              :null}
  
              {checkPermission(['update:intraverse-commission']) ?
                <label
                  className="bg-primary/10 rounded-md cursor-pointer p-2 text-primary/30"
                  onClick={() => edit && edit(params?.row)}
                >
                  <Icon icon="tabler:edit" />
                </label>
              :null}
              {checkPermission(['delete:intraverse-commission']) ?
                <span
                  className="p-2 bg-red-100 text-red-500 rounded-md cursor-pointer"
                  onClick={() => remove && remove(params?.row?._id)}
                  >
                  <Icon icon="material-symbols-light:delete" />
                </span>
              :null}
            </div>
        );
      }}
    </ActionContext.Consumer>
  );
}
